import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/Drywall.jpg";
import {GiBrickWall} from "react-icons/gi";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function DrywallPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Drywall Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover expert drywall services in Charlotte NC. From repairs to installations, our skilled team delivers quality solutions for your home renovation needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><GiBrickWall className={classes.servicesIcon}/> {languageContext.services.DrywallPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.DrywallPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.DrywallPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.DrywallPage.text2}</span>
                            <br/>
                            {languageContext.services.DrywallPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.DrywallPage.text4}</span>
                            <br/>
                            {languageContext.services.DrywallPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.DrywallPage.text6}</span>
                            <br/>
                            {languageContext.services.DrywallPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.DrywallPage.text8}</span>
                            <br/>
                            {languageContext.services.DrywallPage.text9}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default DrywallPage;